export default {
  name: 'rb-3d-dynamic-content',
  functional: true,
  props: {
    tabId: {
      type: Number,
      default: 0,
    },
    isDummyBanner: {
      type: Boolean,
      default: false,
    },
  },
  render(createElement, { slots, props }) {
    const getCurrentTab = (filteredSlots, tabId) => {
      if (!tabId) {
        return filteredSlots[0]
      }
      const currentSlot = filteredSlots.find((slot) => {
        if (!slot?.data?.attrs) {
          return false
        }

        const slotTab = Object.getOwnPropertyDescriptor(slot.data.attrs, 'data-toggle-id')
        return slotTab?.value == tabId
      })
      return currentSlot ?? filteredSlots[0]
    }

    const tabId = props.tabId
    const filteredSlots = (slots().default || [])?.filter((slot) => !!slot.tag)

    const currentSlot = getCurrentTab(filteredSlots, tabId)

    const children = currentSlot?.children?.filter((slot) => slot.tag)
    children?.forEach(
      (child) => (child.componentOptions.propsData.isDummyBanner = props.isDummyBanner)
    )
    const mappedChildren = children?.map((child) => createElement('swiper-slide', [child]))
    return mappedChildren
  },
}
